import {CloseButton, Modal, ModalBody, ModalHeader, Theme} from './AlertModal.styles'
import Image from 'next/image'

type AlertModalProps = {
    theme: Theme
    iconSrc: string
    serviceUrl: string
    closeModal: () => void
}
const AlertModal = ({theme, iconSrc, serviceUrl, closeModal}: AlertModalProps) => {
    return (
        <Modal>
            <ModalHeader>
                <Image width={80} height={80}  src={iconSrc} alt="issue" />
            </ModalHeader>
            <ModalBody>
                <p>{serviceUrl} is unavailable in your country or region</p>
            </ModalBody>
            <CloseButton theme={theme} onClick={closeModal}>Close</CloseButton>
        </Modal>
    )
}

export default AlertModal